import { authGet } from "@api";

import { DeploymentSummaryStats } from "@pages/overview/types";

export const fetchDemoDeploymentSummaryStats = (
  deploymentId: string
): Promise<DeploymentSummaryStats> => {
  return authGet<DeploymentSummaryStats>(
    `/api/agent/deployments/${deploymentId}/analytics/summary/demo_project`
  );
};
